import React from "react";
import { Box, Typography, MenuItem, FormControl, Select } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const formatSkillName = (key) => {
  return key
    .replace("_score", "")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const SkillsChartFilter = ({
  isManager,
  teams,
  skills,
  teamFilter,
  skillFilter,
  setSkillFilter,
  setTeamFilter,
}) => {
  const theme = useTheme();

  console.log("teams in filter", teams);

  return isManager ? (
    <Box>
      <Typography
        sx={{
          fontSize: theme.typography.textXS.fontSize,
          lineHeight: theme.typography.textXS.lineHeight,
          fontWeight: theme.typography.fontWeightLight,
          fontStyle: "italic",
          mb: theme.customSpacing.sm,
        }}
      >
        Filter:
      </Typography>
      <Box sx={{ display: "flex", gap: "10px" }}>
        <FormControl>
          <Select
            value={teamFilter}
            onChange={(e) => setTeamFilter(e.target.value)}
            displayEmpty
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.background.primary,
                  color: theme.palette.text.primary,
                  border: `1.5px solid ${theme.palette.border.brand}`,
                  borderRadius: 2,
                  borderTop: "none",
                },
              },
            }}
            sx={{
              color: "#fff",
              fontWeight: theme.typography.fontWeightMedium,
              borderRadius: 2,
              padding: 0,
              backgroundColor: "transparent",
              border: `1.5px solid ${theme.palette.border.brand}`,
              "& .MuiSelect-select": {
                paddingY: theme.customSpacing.sm,
                paddingX: theme.customSpacing.xl,
                fontSize: "12px",
              },
              "& .MuiSelect-icon": {
                color: "#fff",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          >
            <MenuItem sx={{ fontSize: "12px" }} value="all">
              All Teams
            </MenuItem>
            {teams.map((team) => (
              <MenuItem key={team.id}
                sx={{
                  fontSize: "12px",
                }}
                value={team.id}
              >
                {team.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <Select
            value={skillFilter}
            onChange={(e) => setSkillFilter(e.target.value)}
            displayEmpty
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.background.primary,
                  color: theme.palette.text.primary,
                  border: `1.5px solid ${theme.palette.border.brand}`,
                  borderRadius: 2,
                  borderTop: "none",
                },
              },
            }}
            sx={{
              color: "#fff",
              fontWeight: theme.typography.fontWeightMedium,
              borderRadius: 2,
              padding: 0,
              backgroundColor: "transparent",
              border: `1.5px solid ${theme.palette.border.brand}`,
              "& .MuiSelect-select": {
                paddingY: theme.customSpacing.sm,
                paddingX: theme.customSpacing.xl,
                fontSize: "12px",
              },
              "& .MuiSelect-icon": {
                color: "#fff",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          >
            <MenuItem sx={{ fontSize: "12px" }} value="all">
              All Skills
            </MenuItem>
            {skills.map((skill) => (
              <MenuItem key={skill}
                value={skill}
                sx={{
                  fontSize: "12px",
                }}
              >
                {formatSkillName(skill)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  ) : null;
};

export default SkillsChartFilter;
